import React from 'react';

export default function inProgressCellRenderer() {
    return (
        <div className="running-cell">
            <div className="ui active inline loader mini" />
        </div>
    );
}
